export const R = {
	"YouHaveBlockingConsultation": "You have reached the limit for upcoming consultations.",
	"BlockingConsultationMessage": "To minimize waiting times, there is a limit on how many consultations you can book with a given specialist at a time.",
	"BlockingConsultationMessage2": "If you want to book a new consultation, first you must cancel an existing one. You can do so via",
	"TheConsultationList": "the consultation list",
	"WhoNeedsHelp": "Who needs help?",
	"Myself": "Me ({0})",
	"AddPet": "Add pet",
	"AddChildUnderCertainAge": "Add child under {0}",
	"AddFirstChild": "My child under {0} years",
	"Ok": "Ok",
	"HowDoYouWantToContact": "How do you want to contact {0}?",
	"TextConsultations": "Text consultation",
	"PerConsultation": "per consultation",
	"Free": "Free",
	"Back": "Back",
	"VideoConsultations": "Video consultation",
	"DisclaimerHeader": "Important information",
	"DisclaimerButtonText": "Accept and continue",
	"PhoneNumberLabel": "Your phone number",
	"SubjectRequired": "Subject must be filled out",
	"MessageRequired": "Please include a message",
	"PhoneRequired": "Please provide a phone number. We will use this to get in touch with you in case of technical issues.",
	"InvalidPhoneNumber": "Please enter a valid phone number",
	"Confirm": "Confirm",
	"ConfirmAndSend": "Confirm and send",
	"PhoneFormDescription": "If any technical issues occur, the doctor will contact you by phone. Therefore, please check that your phone number is correct.",
	"PhoneFormHeader": "Confirm your phone number",
	"NotifyOwnDoctorDescription": "To ensure the best treatment process for you, we may, in some cases, inform your own doctor about what we have treated you for at Hejdoktor. It is important that your own doctor, for example, knows which medication you have been prescribed or what advice we have given you.",
	"NotifyOwnDoctorHeader": "Can we inform your personal doctor?",
	"Yes": "Yes",
	"No": "No",
	"DescribeProblemHeader": "What do you need help for?",
	"SubjectLabel": "Subject",
	"MessageLabel": "Message",
	"SubjectPlaceholder": "Brief description of the subject",
	"MessagePlaceholder": "Describe your issue as detailed as possible",
	"ImportantInfoHeader": "If urgent help is needed",
	"Next": "Next",
	"BookOrQueueUpHeader": "Book appointment",
	"QueueUpDescription": "Queue up and be connected to the next available caregiver.",
	"WaitingTime": "Waiting time:&lt;br /&gt;Around &lt;b&gt;{0} minutes&lt;/b&gt;",
	"QueueUpButtonText": "Put me in line",
	"BookConsultation": "Book consultation",
	"SelectCaregiverTitle": "Who would you like to talk to?",
	"SelectCaregiverDescription": "Choose the caregiver you wish to speak with. You will select a time in the next step.",
	"TermsOfService1": "By clicking the button above, you accept Hejdoktor's ",
	"TermsOfService2": "terms of service",
	"YouCanAlsoMessageUs1": "You can also message us. ",
	"YouCanAlsoMessageUs2": "You will receive an answer within 24 hours.",
	"AttachFiles": "Attach files",
	"FileTooLargeErrorMessage": "File is too large (max 30 mb)",
	"DuplicateNameErrorMessage": "Same name as previously uploaded file",
	"ErrorFetchingTimetable": "The timetable could not be loaded. Please try again, and feel free to contact us if the problem persists.",
	"ErrorFetchingWaitingTime": "The expected waiting time could not be loaded. Please try again, and feel free to contact us if the problem persists.",
	"ErrorFetchingCaregivers": "Available caregivers could not be loaded. Please try again, and feel free to contact us if the problem persists.",
	"Today": "Today",
	"TimeZoneWarning": "The times are shown in your local timezone: {0}",
	"OutsideOpeningHours": "It is outside opening hours, so you cannot queue for a consultation. Instead, you can book a consultation below.",
	"PleaseChooseDate": "Please select a time for your consultation",
	"InvalidPayment": "Invalid payment",
	"AllCaregivers": "All caregivers",
	"TimeslotUnavailable": "Unfortunately, the time is already booked, choose another time.",
	"ErrorSchedulingConsultation": "An error occurred while scheduling the consultation. Please try again or contact us if the problem persists.",
	"UnsupportedDeviceVideo": "Unfortunately, video calls do not work in this browser or device. You can still book your consultation from here, but to complete the call you have to use another browser or download our app.",
	"NoAvailableTimeslotsHeader": "Oh no! There are no available timeslots in the near future",
	"NoAvailableTimeslotsDescription": "Write to us at &lt;a href=\"mailto:hej@hejdoktor.dk\"&gt;hej@hejdoktor.dk&lt;/a&gt; if you want to know more about when we will be able to assist you again.",
	"NoTimeslotsForCaregiverOnSelectedDay": "No available slots. Please pick another day or caregiver.",
	"AvailableFrom": "Available from: {0}",
	"FileRejectionsHeader": "The following files were not uploaded",
	"MaxUploadsReached": "Maximum number of files (10) have been reached",
	"AttachmentUploadFailed": "One or more files could not be uploaded. Your message was not sent. Please try again, or contact us if the problem persists.",
	"AttachmentsRequiredErrorMessage": "You must attach at least one image or video to book this consultation.",
	"PrescriptionQuestions": "- Why do you need the medicine?\n    - What is the name of the medicine?\n    - What dosis do you need?\n    - What are you getting the medicine for?",
	"AiNurseModalHeader": "May we ask you a few follow-up questions?",
	"AiNurseModalDescription": "We use AI to ensure that your message contains all the information the doctor needs to help you in the best possible way.\n\nNote: AI can make mistakes. If you find the questions irrelevant, feel free to skip at any time. Your data is not used to train AI models.",
	"Skip": "Skip",
	"GoToQuestion": "Go to questions",
	"AiNurseQuestionsHeader": "Answer questions",
	"AiNurseOverviewHeader": "Your message to the doctor",
	"AiNurseOverviewDescription": "Here you can see your complete message to the doctor. Please check that everything looks correct before sending.",
	"AiNurseSubjectTag": "Subject",
	"AiNurseUpdatedMessageTag": "Updated message to the doctor",
	"AiNurseQuestionsSubheader": "Follow-up questions generated by AI",
	"AiNurseEditMessage": "Edit message",
	"AiNurseSendMessage": "Send message",
	"AiNurseSaveAndContinue": "Save and continue",
	"AiNurseAnswerPlaceholder": "Write your answer here",
	"InsuranceProviderInfoCardWithProviderTitle": "This treatment is not free through {0}",
	"InsuranceProviderInfoCardWithProviderParagraph1": "This treatment is not covered by your free coverage through {0}.",
	"InsuranceProviderInfoCardWithProviderParagraph2": "If you have access through another partner that covers this treatment, you must connect it in your profile before booking.",
	"InsuranceProviderInfoCardNoProviderTitle": "Do you have access to Hejdoktor through one of our partners?",
	"InsuranceProviderInfoCardNoProviderParagraph": "If you have free access to Hejdoktor through a partner that covers this treatment, you must connect it in your profile before booking.",
	"InsuranceProviderInfoCardGoToProfile": "Go to profile",
	"AccessVia": "Access via",
	"Attachments": "Attached files",
	"AdultWarningBookingTitle": "You cannot contact us on behalf of other adults",
	"AdultWarningBookingText": "Adult household members and children over {0} years old must have their own profile so that we can help them. If you have access through one of our partners, you can invite your household members via your profile.",
	"GoToProfile": "Go to profile",
	"OtherHouseholdmembers": "Householdmembers aged {0}+",
	"CurrentPetWeight": "Current weight of the animal",
	"PleaseEnterANumber": "Please enter a number. You may use decimals (e.g. 5,2 or 5.2)",
	"KilosSuffix": "kg",
	"CurrentPetWeightHelperText": "The animal’s weight is important when assessing suspected intoxication. Provide your best estimate if the weight is unknown.",
	"CurrentPetWeightPlaceholder": "E.g., \"5.2\""
}